// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kmRi9","label":"styles_label__pKBsn","icon":"styles_icon__nV66d"};